import React, { useState } from 'react';
import { Modal, UploadFile, message } from 'antd';
import { useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { RcFile } from 'antd/lib/upload/interface';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { modelAPI } from 'apis/resource/modelAPI';
import UploadZip from '../_component/UploadZip';

/**
 * * 리소스 - 모델 파일 업로드
 */

interface IProps {
  visible: {
    modelRegister: boolean;
    modelUpdate: boolean;
    modelDelete: boolean;
    modelReset: boolean;
    assetsRegister: boolean;
    assetsUpdate: boolean;
    zip: boolean;
    name: string;
  };
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  data: any;
}

const ModelMotionRegisterModal = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  data,
}: IProps) => {
  const { t } = useTranslation();
  const { projectId } = useParams();

  const [zip, setZip] = useState<UploadFile | null>(null);
  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId && data) {
      if (!zip) {
        handleMessage(message, 'error', 'Please select zip');
      } else {
        const formData = new FormData();
        formData.append('file', zip as RcFile);
        try {
          setLoading(true);
          await modelAPI.characterUploadZip(projectId, data.model_id, formData);
          setRefresh(!refresh);
          setLoading(false);
          handleClose();
        } catch (err) {
          setLoading(false);
          handleMessage(message, 'error', 'Upload failed');
        }
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, assetsRegister: false });
    setZip(null);
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };
  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.registerMotionModal.title',
      )}
      open={visible.assetsRegister}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.create')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <UploadZip
        zip={zip}
        setZip={setZip}
        placeholder='storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.registerMotionModal.formContent'
        requiredSubtitle={
          <ul>
            <li className='turText'>
              zip 파일을 업로드하면 이전 파일을 덮어씁니다.
            </li>
            <li className='turText'>최대 8MB까지 업로드 가능합니다.</li>
          </ul>
        }
      />
    </CustomModal>
  );
};

export default ModelMotionRegisterModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
